import { ActionIcon as MantineActionIcon, ActionIconProps, ElementProps } from '@mantine/core';
import styles from './ActionIcon.module.css';
import { variants, VariantProps } from '../styles/button/variants';
import { FC } from 'react';
import { WithRequired } from '../../types/withRequired';

type ActionIconComponentProps = VariantProps &
    ActionIconProps &
    WithRequired<ElementProps<'button', keyof ActionIconProps>, 'aria-label'>;

// for typing, see https://mantine.dev/guides/typescript/#components-props-types
export const ActionIcon: FC<ActionIconComponentProps> = ({ children, appearance, intent, ...props }) => {
    return (
        <MantineActionIcon
            className={variants({ intent, appearance, disabled: props.disabled })}
            style={{
                // prevent mantine from setting a default here as it overrides some of our styling
                // we could use the unstyled prop instead but some of the basic styling is actually helpful
                '--ai-color': undefined,
            }}
            classNames={{
                icon: styles.icon,
            }}
            {...props}
        >
            {children}
        </MantineActionIcon>
    );
};
